module.exports = {

	setCookie: function(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	},

	getCookie: function(cname, cdefault) {

		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}

		return cdefault;
	},

	/**
	 * Holds date parse cache
	 */
	dateParseCache: {},

	/**
	 * Parses date in format d.m.Y
	 *
	 * @param      string  date    The date in format d.m.Y
	 * @return     {Date}          Date object
	 */
	parseDate: function(date) {

		if (window.Utils.dateParseCache[date]) {
			return window.Utils.dateParseCache[date];
		}

		if (typeof date !== "string") {
			return null;
		}

		var dateString = date;
		var date = date.split(".");

		if (date.length != 3) {
			return null;
		}

		window.Utils.dateParseCache[dateString] = new Date(date[2], date[1] - 1, date[0], 0, 0, 0, 0);
		return window.Utils.dateParseCache[dateString];
	},

	pad: function(value, length, pad) {
		value = "" + value;

		if ( value.length < length ) {
			var padStr = Array(length + 1 - value.length).join("" + pad);
			return padStr + value;
		}

		return value;
	}
	
}